import { connect } from 'react-redux'
import Component from 'components/DashboardViewer/Filter'

export default connect()(Component)
